(function(){
  function fix(){
    var shop='/collections/all';
    var lanes=document.querySelectorAll('.sm9-lane-grid .sm9-lane');
    if(lanes.length>=3){
      var card=lanes[2],h=card.querySelector('.sm9-lane-copy h3'),b=card.querySelector('.sm9-lane-copy b'),img=card.querySelector('img');
      card.setAttribute('href',shop);
      if(h)h.textContent='SHOP';
      if(b)b.textContent='PINS • APPAREL • PRINTS • MORE →';
      if(img)img.setAttribute('alt','Shop StyleMechanics');
    }
    document.querySelectorAll('.sm9-shop-head a,.sm9-links a').forEach(function(a){
      var text=(a.textContent||'').replace(/\s+/g,' ').trim().toUpperCase();
      if(text==='SHOP'||text.indexOf('VIEW ALL')>-1)a.setAttribute('href',shop);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
  document.addEventListener('shopify:section:load',fix);
})();